import { Injectable } from '@angular/core';
import { Inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ICoverage } from '../_shared/interfaces/ICoverage';
import { CustomResponse } from '../_shared/classes/CustomResponse';
import { SessionStorageUtils } from '../util/session-storage';
import { IUser } from '../user/models/IUser';

@Injectable({
  providedIn: 'root',
})
export class CoverageService {
  arcApiBaseUrl;
  fortunaApiBaseUrl;
  private url: string = "api/coverage/";
  user: IUser;

  constructor(private http: HttpClient, @Inject('FORTUNA_BASE_URL') fortunaApiBaseUrl: string, @Inject('ARC_API_URL') arcApiBaseUrl: string) {
    this.arcApiBaseUrl = arcApiBaseUrl;
    this.fortunaApiBaseUrl = fortunaApiBaseUrl;
    this.user = SessionStorageUtils.getUser();
  }

  get(id: number): Observable<CustomResponse<any>> {
    return this.http.get<CustomResponse<any>>(this.fortunaApiBaseUrl + this.url + id);
  }

  getByQuote(quote: number): Observable<CustomResponse<any>> {
    return this.http.get<CustomResponse<any>>(this.fortunaApiBaseUrl + this.url + "quote/" + quote);
  }

  save(item: ICoverage) {
    return this.http.post<CustomResponse<any>>(this.fortunaApiBaseUrl + this.url, item);
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.log("error in service");
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
